import { ReactElement } from "react";

export const Head = (): ReactElement => {
  return (
    <div className={'head bubble bubble_green'}>
      <div className={'logos'}></div>
    </div>
  )
}